import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
	display: flex;
	gap: 5px;
	align-items: center;
`;

export const Wrapper = styled.div`
	margin-top: 40px;

	.exam-preview-header-icon {
		width: 36px;
		height: 36px;
	}
`;
